import { registerWeapon } from './registry';
import { DEFAULT_CRATER } from '../terrain/crater-shapes';

export const MORTAR = registerWeapon({
  id: 'mortar',
  name: 'Mortar',
  description: 'Bread and Butter. Good damage, big booms, trick shots.',
  tier: 'CHEAP',
  rarity: 'common',
  projectileRadius: 8,
  projectileSpeed: 0.55,
  color: 0x00ffff,
  gravity: 0.15,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 38,
  blastRadius: 100,
  knockbackMult: 0.08,
  knockbackRadius: 1.2,
  shakeIntensity: 2.5,
  particleScale: 1.5,
  craterShape: DEFAULT_CRATER,
  edgeguard: { chargeFrames: 30, threshold: 45 },
});
